import { useCallback } from 'react'
import { HOME_PRODUCT_KEYS, SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'
import PATHS from '@/routes/paths'

export function useSecondaryPulse({ navigate, setSelectedThreadId, setHomeView, setHomeProduct }) {
  return useCallback(() => {
    setHomeProduct(HOME_PRODUCT_KEYS.CHAT)
    setHomeView(SECONDARY_VIEW_KEYS.HOME_MAIN)
    setSelectedThreadId(null)
    navigate(PATHS.PULSE)
  }, [navigate, setHomeProduct, setHomeView, setSelectedThreadId])
}
